export const LOADING_FORMACION_COLABORADOR = "LOADING_FORMACION_COLABORADOR";
export const SAVE_LOADING_FORMACION_COLABORADOR = "SAVE_LOADING_FORMACION_COLABORADOR";
export const GET_FORMACION_COLABORADOR= "GET_FORMACION_COLABORADOR";
export const FORM_FAIL = "FORM_FAIL";
export const FORMACION_COLABORADOR_FAIL = "FORMACION_COLABORADOR_FAIL";
